module.exports = __webpack_public_path__ + "img/skyline-bg.d21e7828.jpg";